import cx from 'classnames';
import styles from './JackpotTabs.module.scss';

import { FC } from 'react';

import { Typography } from '@shared/Typography';
import { JackpotTabEnum } from '@entities/jackpot';
import { useAppDispatch, useAppSelector } from '@app/store';
import { setJackpotTab } from '@pages/JackpotPage/store/jackpotSlice';
import { useJackpotHighlightedTabs } from './hooks/useJackpotHighlightedTabs';

const tabs = [
  { label: 'Leagues', tab: JackpotTabEnum.AllJackpots },
  { label: 'Leaders', tab: JackpotTabEnum.TopPlayers },
  { label: 'Top Ref', tab: JackpotTabEnum.PartnersJackpot },
  { label: 'Platinum', tab: JackpotTabEnum.PlatinumJackpot },
  { label: 'My', tab: JackpotTabEnum.MyJackpots },
];

export const JackpotTabs: FC = () => {
  const dispatch = useAppDispatch();
  const jackpotTab = useAppSelector((state) => state.jackpot.jackpotTab);

  const highlightTabs = useJackpotHighlightedTabs();

  return (
    <div className={styles.jtContainer}>
      {tabs.map((tab) => {
        const isSelected = tab.tab === jackpotTab;

        const isHighlighted =
          tab.tab !== JackpotTabEnum.AllJackpots && highlightTabs[tab.tab] && !isSelected;

        return (
          <div key={tab.tab} className={styles.jtTabWrapper}>
            <Typography
              component="h2"
              onClick={() => dispatch(setJackpotTab(tab.tab))}
              data-tutorial={tab.tab === JackpotTabEnum.MyJackpots ? 'my-tab' : undefined}
              className={cx(styles.jtTab, {
                [styles.jtSelectedTab]: isSelected,
                [styles.jtHighlighted]: isHighlighted,
              })}
            >
              {tab.label}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};
